import React from "react";
import { ArticleRounded, PhotoRounded } from "@mui/icons-material";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton
} from "@mui/material";

function Sidebar({mode, setMode}) {
  return (
    <Box 
      className="h-screen border-r"
      width={{md: 90, lg: 180}}
      sx=
        {
          { 
            display: { xs: 'none', md: 'block'},
            boxShadow: 1,
            justifyContent: 'center'
          }
        }
    >
      <List>
        <ListItem>
          <ListItemButton component="a" href="/" sx={{ borderRadius: 3 }}>
            <ListItemIcon>
              <ArticleRounded />
            </ListItemIcon>
            <ListItemText primary="Home" sx={{display: { md: 'none', lg: 'block' }}} />
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton component="a" href="/photo" sx={{ borderRadius: 3 }}>
            <ListItemIcon>
              <PhotoRounded />
            </ListItemIcon>
            <ListItemText primary="사진" sx={{display: { md: 'none', lg: 'block' }}} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
}

export default Sidebar;